/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { createContext, type ForwardedRef, forwardRef } from 'react';
import { type ContextValue, Dialog as DialogCore, type DialogProps as DialogPropsCore, Modal as ModalCore, type ModalOverlayProps, useContextProps } from 'react-aria-components';
import { breakpoints, zIndices } from '../../constants.stylex';
import { $ } from '../../tokens.stylex';

interface DialogProps extends Omit<DialogPropsCore, 'style' | 'className'>, Pick<ModalOverlayProps, 'defaultOpen' | 'isKeyboardDismissDisabled' | 'isOpen' | 'shouldCloseOnInteractOutside' | 'isDismissable'> {
  style?: stylex.StyleXStyles;
}

const DialogContext = createContext<ContextValue<DialogProps, HTMLDivElement>>({});

const Dialog = forwardRef((props: DialogProps, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, DialogContext);

  const {
    style,
    children,
    defaultOpen,
    isKeyboardDismissDisabled,
    isOpen,
    shouldCloseOnInteractOutside,
    isDismissable,
    ...coreProps
  } = props;

  return (
    <ModalCore
      defaultOpen={defaultOpen}
      isKeyboardDismissDisabled={isKeyboardDismissDisabled}
      isOpen={isOpen}
      shouldCloseOnInteractOutside={shouldCloseOnInteractOutside}
      isDismissable={isDismissable}
      {...stylex.props(modalStyles.base)}>
      {(renderProps) => (
        <DialogCore
          ref={ref}
          {...stylex.props(
            styles.base,
            (renderProps.isExiting || renderProps.isEntering) && styles.transitioning,
            style,
          )}
          {...coreProps}
          {...renderProps}>
          {children}
        </DialogCore>
      )}
    </ModalCore>
  );
});

const styles = stylex.create({
  base: {
    backgroundColor: $.surface00,
    borderRadius: 16,
    boxShadow: $.shadowCenter060Medium,
    display: 'flex',
    flexDirection: 'column',
    height: 'fit-content',
    maxHeight: '80%',
    opacity: {
      default: 1,
      ':is([data-entering], [data-exiting])': 0,
    },
    outline: 'none',
    overflow: 'hidden',
    padding: 20,
    paddingTop: {
      default: 20,
      [breakpoints.small]: 28,
    },
    position: 'relative',
    transitionDuration: '200ms',
    transitionProperty: 'opacity, transform',
    transitionTimingFunction: 'ease-in-out',
  },
  transitioning: {
    opacity: 0,
    transform: 'translateY(-25px)',
  },
});

const modalStyles = stylex.create({
  base: {
    alignItems: 'center',
    backgroundColor: $.opacity48,
    display: 'flex',
    height: 'var(--visual-viewport-height)',
    justifyContent: 'center',
    left: 0,
    opacity: {
      default: 1,
      ':is([data-entering], [data-exiting])': 0,
    },
    position: 'fixed',
    top: 0,
    transitionDuration: '200ms',
    transitionProperty: 'opacity',
    transitionTimingFunction: 'ease',
    width: '100vw',
    zIndex: zIndices.modal,
  },
});

const DIALOG_SLOTS = {
  TITLE: 'title',
  TOP_BAR: 'top-bar',
  BOTTOM_BAR: 'bottom-bar',
  CLOSE: 'close',
};

export { Dialog, DIALOG_SLOTS, DialogContext, type DialogProps };
